<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      top
      :timeout="timeout"
      multi-line
      :color="snackcolor"
    >
      {{ text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

<!-- Confirm User Email -->
    <v-dialog 
      v-model="emailDialog" 
      persistent 
      max-width="600"
    >
      <v-form ref="dialog" v-model="validBox" lazy-validation>
        <v-card>
          <v-toolbar class="primary" dark>
            <v-toolbar-title class="subheading">Change my email address</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            
          </v-toolbar>
          <v-card-text>
            <v-container>
              <div>
                <v-flex xs12>
                  <!-- new email address -->
                  <v-text-field
                    ref="confirmemailfield"
                    v-model="newEmail"
                    :error="emailError"
                    :error-messages="emailErrorMsg"
                    label="New Email Address"
                    name="new email"
                    type="text"
                    :rules="emailRules"
                    class='mx-4 mt-1 mb-2'
                  />
                </v-flex>
                <v-flex xs12>
                  
                    Submitting a new email address will change your Mentor Directory user id to that address.
                    <br>
                    In future you will need to use the new email address to log into Mentor Directory.
                  
                </v-flex>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              outlined
              color="secondary" 
              class="body-2 font-weight-bold white--text mr-8 mb-5"
              @click="emailDialog = false">
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              outlined
              color="primary" 
              class="body-2 font-weight-bold white--text mr-8 mb-5"
              @click="changeEmail"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-layout text-xs-center wrap>
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card>
          <v-toolbar class="primary" dark>
            <v-toolbar-title class="title">Run https Callable Cloud Functions for System Admin</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            
          </v-toolbar>
          <v-card-text>
            <v-layout align-center justify-center column wrap>
              <v-btn
                text
                light 
                outlined
                @click="sayHello">
                  Say Hello to the World
              </v-btn>
              <v-btn
                text
                light 
                outlined
                @click="newProfiles">
                  Copy user docs to profile docs
              </v-btn>
              <v-btn
                text
                light 
                outlined
                @click="emailDialog = true">
                  Change current user's email address
              </v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import "firebase/functions"

export default {
  name: 'welcomeAdmin',
  data () {
    return {
      validBox: false,
      formData: {},
      editMode: false,
      snackbar: false,
      y: 'top',
      x: null,
      snackcolor: 'yellow',
      mode: '',
      timeout: 6000,
      text: 'Hello, I\'m a snackbar',
      emailDialog: false,
      newEmail: null,
      emailError: false,
      emailErrorMsg: null,
      emailRules: [
        v => /^(?:(?:[\w`~!#$%^&*\-=+;:{}'|,?\/]+(?:(?:\.(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)*"|[\w`~!#$%^&*\-=+;:{}'|,?\/]+))*\.[\w`~!#$%^&*\-=+;:{}'|,?\/]+)?)|(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)+"))@(?:[a-zA-Z\d\-]+(?:\.[a-zA-Z\d\-]+)*|\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])$/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  methods: {    
    sayHello () {
      // get function reference
      const sayHello = firebase.app().functions('europe-west2').httpsCallable('sayHello');
      sayHello().then(result => {
        console.log(result.data);
      });
    },
    newProfiles () {
      this.$store.commit('setProgressColour',"yellow")
      this.$store.commit('setStoreLoading',true)
      // get function reference
      const createNewProfiles = firebase.app().functions('europe-west2').httpsCallable('createNewProfiles');
      createNewProfiles()
      .then(result => {
        this.$store.commit('setStoreLoading',false)
        this.snackbar = true
        this.snackcolor = 'success'
        this.text = result.data
      })
      .catch(error => {
        this.$store.commit('setStoreLoading',false)
        this.snackbar = true
        this.snackcolor = 'error'
        this.text = error.message
      });
    },
    changeEmail () {
      // make sure the front end validation has been passed
      if (this.$refs.dialog.validate()) {
        // make sure user has entered an email address
        if (!this.newEmail) {
          // user hasn't entered an email address
          this.emailError = true
          this.emailErrorMsg = 'Enter your new email address to continue'
        } else {
          // close the dialog box
          this.emailDialog = false


          this.$store.commit('setProgressColour',"red")
          this.$store.commit('setStoreLoading',true)
          // get function reference
          const changeUserEmail = firebase.app().functions('europe-west2').httpsCallable('changeUserEmail');
          changeUserEmail({newEmail: this.newEmail})
          .then(result => {
            this.$store.commit('setStoreLoading',false)
            this.snackbar = true
            this.snackcolor = 'success'
            this.text = result.data
            console.log(result.data)
            setTimeout(() => {
              this.logOut()
            },2000)
          })
          .catch(error => {
            this.$store.commit('setStoreLoading',false)
            this.snackbar = true
            this.snackcolor = 'error'
            this.text = 'Error: ' + error.message
          });
        }
      }
    },
    logOut: function() {
      firebase.auth().signOut()
        .then(() => {
          this.$router.push('/')
        })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.card-form-list {
    margin-top: 10px;
}

.card-study-site {
    margin-top: 10px;
}
</style>
